var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner",style:({
      width: _vm.size + 'px',
      height: _vm.size + 'px',
      borderTopColor: _vm.color,
      borderRightColor: _vm.color,
      borderBottomColor: _vm.color,
      borderLeftColor: 'transparent'
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }